<template>
  <div class="sf-view">
    <div v-if="error" class="sf-notice sf-notice--danger">
      <i class="fas fa-exclamation-circle"></i>
      <span>خطایی رخ داده است، دوباره تلاش کنید.</span>
    </div>

    <template v-else>
      <div class="sf-toolbar">
        <p class="sf-toolbar__hint">امضاهای دیجیتال ثبت‌شده شما در این بخش نمایش داده می‌شوند.</p>
        <button type="button" class="sf-btn sf-btn--primary" @click="Introducenew()">
          <i class="fas fa-plus"></i>
          ثبت امضای دیجیتال جدید
        </button>
      </div>

      <div v-if="SignList.length == 0" class="sf-empty sf-empty--center">
        <span class="sf-empty__icon"><i class="fas fa-signature"></i></span>
        امضایی برای نمایش وجود ندارد
      </div>

      <ul v-else class="sf-list">
        <li v-for="(sign, index) in SignList" :key="index" class="sf-item">
          <div class="sf-item__main">
            <div class="sf-item__title">{{ sign.fa_first_name + ' ' + sign.fa_last_name }}</div>
          </div>
          <div class="sf-item__metas">
            <div class="sf-meta">
              <span class="sf-meta__label">کد ملی</span>
              <span class="sf-meta__value">{{ sign.national_code }}</span>
            </div>
            <div class="sf-meta">
              <span class="sf-meta__label">تاریخ انقضا</span>
              <span class="sf-meta__value" dir="ltr">{{ sign.expire_date }}</span>
            </div>
            <div class="sf-meta">
              <span class="sf-meta__label">وضعیت</span>
              <span class="sf-meta__value">
                <span v-if="sign.certificate_status.trim() == 'PENDING'" class="sf-badge sf-badge--warning">تکمیل نشده</span>
                <span v-if="sign.certificate_status.trim() == 'صادر شد'" class="sf-badge sf-badge--success">ثبت شد</span>
              </span>
            </div>
          </div>
          <div class="sf-item__actions">
            <button
              v-if="sign.certificate_status.trim() == 'PENDING'"
              type="button"
              class="sf-btn sf-btn--soft sf-btn--sm"
              @click="CreateSign(sign)"
            >
              تکمیل ثبت نام
            </button>
          </div>
        </li>
      </ul>
    </template>
  </div>
</template><script>
export default {
  data() {
    return {
      SignList: [],
      error: false,
    }
  },
  created() {
    this.GetList()
  },
  methods: {
    GetList() {
      var GetParams = { method: 'GET', action: 'ElectronicSafte/' + this.$session.get('UserInfoNetPa').wwwtblAzaId, arryfildValue: null }
      this.$PostData_netpatoken(GetParams).then((result) => {
        if ((result.status = 'success')) {
          this.error = false
          this.SignList = result.data
          this.$emit('loaded', result.data)
        } else {
          this.error = true
        }
      })
    },
    Introducenew() {
      this.$emit('introduceNew', true)
    },
    CreateSign(sign) {
      this.$emit('CompeleteSign', sign)
    },
    SafteRecieve(sign) {
      this.$emit('SafteRecieve', sign)
    },
    SafteRecieve(sign) {
      this.$emit('SafteRecieve', sign)
    },
    ListSafte(sign) {
      this.$emit('ListSafte', sign)
    },
  },
}
</script>
